import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type StarfishAlarmAcknowledgeEndpointSpecification = ApiEndpointSpecification;
export const StarfishAlarmAcknowledgeEndpointSpecification: StarfishAlarmAcknowledgeEndpointSpecification = {
    url: '/api/alarm/acknowledgement',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'StarfishAlarmAcknowledgeRequestParams',
    requestBodySchemaName: 'StarfishAlarmAcknowledgeRequestBody',
    okResponseSchemaName: 'StarfishAlarmAcknowledgeOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3.0
};

export const invokeStarfishAlarmAcknowledge = Helpers.makeApiRequestFn<
    Types.StarfishAlarmAcknowledgeRequestParams,
    Types.StarfishAlarmAcknowledgeRequestBody,
    Types.StarfishAlarmAcknowledgeOkResponse
>(StarfishAlarmAcknowledgeEndpointSpecification);
